export default "__VITE_ASSET__BiO7MdEe__"